import { createFileRoute } from "@tanstack/react-router";
import AdminGuard from "@/components/admin/AdminGuard";
import Admin from "@/pages/Admin";

export const Route = createFileRoute("/admin/$")({
  component: () => (
    <AdminGuard><Admin /></AdminGuard>
  ),
});
